import {Button, Checkbox, FormControlLabel, makeStyles, Popover, Radio, RadioGroup} from "@material-ui/core";
import {useDispatch, useSelector} from "react-redux";
import {
  moveNextPage,
  sendNeedHelpEmail,
  updateUserMetrics
} from "../../../../store/actions/creator/creatorExperienceBuilder";
import {useCallback, useEffect, useState} from "react";
import clsx from 'clsx';
import CreatorBtn from "../../../atoms/creator/experienceBuilderEnterBtn";
import Config from '../../../../config/config'
import UtilService from "../../../../helper/service";
import {useHistory} from "react-router";

const useStyles = makeStyles(() => ({
  mainTitle: {
    fontSize: 48,
    fontFamily: 'Spartan-bold',
    color: '#212D40',
    textAlign: 'center',
    marginTop: '10px!important',
    marginBottom: '20px!important',
    '@media only screen and (max-width: 600px)': {
      fontSize: 20
    }
  },
  subTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'roboto-light',
    textAlign: 'center',
    fontSize: 30,
    color: '#717E8B',
    lineHeight: '40px'
  },
  selectIconDiv: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 30
  },
  selectIcon: {
    width: 265,
    height: 171,
    cursor: 'pointer'
  },
  guideDiv: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  guideTitle: {
    color: '#212D40',
    fontSize: 18,
    fontFamily: 'roboto-bold',
    marginTop: 18
  },
  description: {
    fontFamily: 'roboto-light',
    fontSize: 18,
    color: '#212D40'
  },
  optionText: {
    color: '#697683',
    fontSize: 14,
    fontFamily: 'roboto-regular'
  },
  radioOption: {
    display: 'flex',
    alignItems: 'center'
  },
  checkbox: {
    '& .MuiSvgIcon-root': {
      width: 27,
      height: 27,
      marginBottom: '1px'
    },
    '&:hover': {
      backgroundColor: 'transparent'
    },
  },
  checkedLabel: {
    fontWeight: 'bold'
  },
  width700: {
    width: 700
  },
  infoIcon: {
    width: 24,
    height: 24,
    marginLeft: 6,
    cursor: 'pointer'
  },
  popover: {
    marginLeft: 15
  },
  popoverDiv: {
    fontFamily: 'roboto-regular',
    fontSize: 12,
    padding: 20,
    background: '#F0F0F0',
    color: '#212D40',
    maxWidth: 300,
    lineHeight: '15px'
  },
  popoverBtn: {
    minWidth: '140px',
    fontFamily: 'roboto-regular',
    fontSize: 12,
    padding: '10px 10px',
    background: '#212D40',
    color: '#fff',
    borderRadius: 10,
    '&:hover': {
      background: '#2D3740',
      color: '#fff',
    },
    textTransform: 'none'
  },
  radioBtn: {
    marginTop: '2px'
  },
  helpLink: {
    color: '#017AEF',
    textDecoration: 'none'
  }
}));

const PlanningMeasure = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || '{}') : "";
  const firstName = localStorage.getItem('firstName') ? localStorage.getItem('firstName') : '';
  const lastName = localStorage.getItem('lastName') ? localStorage.getItem('lastName') : '';
  const organization =  localStorage.getItem("departmentAlias") ? localStorage.getItem("departmentAlias") : '';

  const { userMetrics, page } = useSelector((state: any) => state.creatorExperienceBuilder);
  const { userPreferencesData } = useSelector((state: any) => state.authUser);
  const {
    path, measureWay, compatible, save_setting, sessionCode, asyncParticipants, asyncLastActivePage, modLastActivePage
  } = userMetrics;
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorEl1, setAnchorEl1] = useState(null);
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const open1 = Boolean(anchorEl1);
  const id1 = open1 ? 'simple-popover' : undefined;

  const handleUserKeyPress = (event: any) => {
    if (event.keyCode === 13 && ((measureWay === 1 && compatible !== -1) || measureWay === 2)) {
      goNext();
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', handleUserKeyPress);
    return () => {
      window.removeEventListener('keydown', handleUserKeyPress);
    };
  });

  useEffect(() => {
    if (history.location.hash !== '#planning') {
      UtilService.addHashTag(history, location.pathname, 'planning');
    }
  }, []);

  const onMeasureWay = (index: number) => {
    dispatch(updateUserMetrics('measureWay', index));
  };

  const getLinedUpSRC = useCallback(() => {
    return measureWay === 1
      ? '/assets/icons/experiencebuilder/linedup-select.svg'
      : '/assets/icons/experiencebuilder/linedup-unselect.svg'
  }, [measureWay]);

  const getSomeHelpSRC = useCallback(() => {
    return measureWay === 2
      ? '/assets/icons/experiencebuilder/somehelp-select.svg'
      : '/assets/icons/experiencebuilder/somehelp-unselect.svg'
  }, [measureWay]);

  const onChangeOption = (event: any) => {
    const value = Number(event.target.value);
    dispatch(updateUserMetrics('compatible', value));

    if (value === 2) { // not add user as a participant
      const _asyncParticipants = asyncParticipants.filter((participant: any) => participant.email !== loginUserData.username);
      dispatch(updateUserMetrics('asyncParticipants', _asyncParticipants));
    } else { // add user as a participant
      const me = asyncParticipants.find((p: any) => p.email === loginUserData.username);
      if (!me) {
        const participant = {
          email: loginUserData.username,
          tags: '',
          is_csv: false
        };
        dispatch(updateUserMetrics('asyncParticipants', asyncParticipants.concat([participant])));
      }
    }
  };

  const getName = useCallback(() => {
    if (firstName && lastName) {
      return `${firstName} ${lastName}`;
    }
    return `${loginUserData.first_name} ${loginUserData.last_name}`
  }, [firstName, lastName, loginUserData]);

  const getTitle = useCallback(() => {
    if (userPreferencesData.length > 0) {
      const titleObj = userPreferencesData.find((data: any) => data.preference_name === 'TITLE');
      return titleObj ? titleObj.preference_information : ''
    }
    return '';
  }, [userPreferencesData]);

  const goNext = () => {
    if (measureWay === 2 && !loginUserData.disable_transactional_emails) { // need help
      const request = {
        name: getName(),
        email: Config.SUCCESS_EMAIL,
        user_email: loginUserData.username,
        title: getTitle(),
        organization: organization ? organization : loginUserData.department_alias,
        experience_id: sessionCode
      };
      dispatch(sendNeedHelpEmail(apolloClient.client, request, () => {}))
    }
    dispatch(moveNextPage(page + 1));
    if (path === 1) {
      (asyncLastActivePage < page + 1) && dispatch(updateUserMetrics('asyncLastActivePage', page + 1));
    } else {
      (modLastActivePage < page + 1) && dispatch(updateUserMetrics('modLastActivePage', page + 1));
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
    setAnchorEl1(null);
  };

  const onClickCoospo = () => {
    window.open(Config.COOSPO_LINK, "__blank");
  };

  const onClickAppleWatch = () => {
    window.open(Config.APPLE_WATCH_LINK, "__blank");
  };

  const onSaveSetting = (isSave: boolean) => {
    dispatch(updateUserMetrics('save_setting', isSave));
  };

  return (
    <div style={{ position: 'absolute', top: '80px' }}>
      <p className={classes.mainTitle}>
        Who are you planning to measure?
      </p>
      <div className={classes.subTitle}>
        Do you have a group of people you expect to measure,<br />
        or do you need us to help you find some?
      </div>
      <div className={classes.selectIconDiv}>
        <div className={classes.guideDiv}>
          <img
            className={classes.selectIcon}
            src={getLinedUpSRC()}
            alt={'LinedUp'}
            onClick={() => onMeasureWay(1)}
            onMouseOver={e => (e.currentTarget.src = "/assets/icons/experiencebuilder/linedup-select.svg")}
            onMouseOut={e => e.currentTarget.src = getLinedUpSRC()}
          />
          <div className={classes.guideTitle}>I have the people lined up</div>
        </div>
        <div style={{ width: 80 }}/>
        <div className={classes.guideDiv}>
          <img
            className={classes.selectIcon}
            src={getSomeHelpSRC()}
            alt={'SomeHelp'}
            onClick={() => onMeasureWay(2)}
            onMouseOver={e => (e.currentTarget.src = "/assets/icons/experiencebuilder/somehelp-select.svg")}
            onMouseOut={e => e.currentTarget.src = getSomeHelpSRC()}
          />
          <div className={classes.guideTitle}>I could use some help</div>
        </div>
      </div>
      <div style={{ marginTop: 60 }}>
        {measureWay === 1 && (
          <>
            <div className={clsx(classes.description, classes.radioOption)}>
              Do you have a compatible smartwatch and want to join as a participant yourself?
              <img
                className={classes.infoIcon}
                alt="Info"
                src={'/assets/icons/info.svg'}
                onClick={(e: any) => setAnchorEl1(e.currentTarget)}
              />
              <Popover
                id={id1}
                open={open1}
                anchorEl={anchorEl1}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                className={classes.popover}
              >
                <div className={classes.popoverDiv} style={{ maxWidth: 400 }}>
                  You can review our list of compatible devices&nbsp;
                  <a className={classes.helpLink} href={`${Config.COMPANY_URL}/device_requirements`} target={'_blank'} rel={'noreferrer'}>
                    here
                  </a>.
                </div>
              </Popover>
            </div>
            <RadioGroup
              aria-label="Option"
              name="radio-buttons-group"
              onChange={e => onChangeOption(e)}
              style={{ width: 600, marginTop: 15 }}
            >
              <FormControlLabel
                value={0}
                control={<Radio className={classes.radioBtn} color="primary" value={0} checked={compatible === 0} />}
                label={
                  <span className={classes.optionText} style={compatible === 0 ? {fontFamily: 'roboto-bold'} : {}}>
                    Yes, I do
                  </span>
                }
              />
              <FormControlLabel
                value={1}
                control={<Radio className={classes.radioBtn} color="primary" value={1} checked={compatible === 1} />}
                label={
                  <span className={classes.optionText} style={compatible === 1 ? {fontFamily: 'roboto-bold'} : {}}>
                    I would love to participate, but don’t have one of the compatible smartwatches
                  </span>
                }
                onClick={(e: any) => setAnchorEl(e.currentTarget)}
              />
              <FormControlLabel
                value={2}
                control={<Radio className={classes.radioBtn} color="primary" value={2} checked={compatible === 2} />}
                label={
                  <span className={classes.optionText} style={compatible === 2 ? {fontFamily: 'roboto-bold'} : {}}>
                    No, thanks
                  </span>
                }
              />
            </RadioGroup>
            <FormControlLabel
              style={{ marginTop: 50, marginBottom: -50 }}
              control={
                <Checkbox
                  className={classes.checkbox}
                  checked={save_setting}
                  onChange={(e) => onSaveSetting(e.target.checked)}
                  name="skip"
                  color="default"
                />
              }
              label={
                <span className={clsx(classes.description, save_setting && classes.checkedLabel)}>
                  Save these settings and skip this step in the future
                </span>
              }
            />
          </>
        )}
        {measureWay === 2 && (
          <>
            <div className={clsx(classes.description, classes.width700)}>
              No worries. We’ve emailed our Customer Success team about your need. They will reach out to you shortly to discuss options.
            </div>
            <div className={clsx(classes.description, classes.width700)} style={{ marginTop: 80 }}>
              In the meantime, click Next to be shown options of different ways you can invite your own participants and to finish setting up your Experience for measurement.
            </div>
          </>
        )}
      </div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        className={classes.popover}
      >
        <div className={classes.popoverDiv} style={{ maxWidth: 350 }}>
          No worries. If you’re interested, we’ve made it easy to order a device and get it shipped to any US address.
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 20 }}>
            <Button className={classes.popoverBtn} color='primary' size='large' onClick={onClickCoospo}>
              Coospo Fitness Band
            </Button>
            <Button className={classes.popoverBtn} color='primary' size='large' onClick={onClickAppleWatch}>
              Apple Watch
            </Button>
          </div>
        </div>
      </Popover>
      {((measureWay === 1 && compatible !== -1) || measureWay === 2) && <CreatorBtn goNext={goNext} title={'Next'} isRight={true} showArrow />}
    </div>
  )
};

export default PlanningMeasure;